import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.scss";
import * as serviceWorker from "./serviceWorker";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { Provider } from "react-redux";
import configureStore from "store/configureStore";
import { PersistGate } from "redux-persist/integration/react";

export const { store, persistor } = configureStore();

const router = createBrowserRouter([
  {
    path: "*",
    element: (
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <App />
        </PersistGate>
      </Provider>
    ),
  },
]);

const root = createRoot(document.getElementById("root"));

root.render(<RouterProvider router={router} />);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
